export const getExternalData = ({ external }) => external.external;
export const getExternalLoading = ({ external }) => external.loaders.common;
export const getError = ({ external }) => external.errors.error;
export const getSuccessEdit = ({ external }) => external.success.edit;
export const getSuccess = ({ external }) => external.success.success;
